import { render } from "./AcademyPage.vue?vue&type=template&id=7c320558&scoped=true"
import script from "./AcademyPage.vue?vue&type=script&lang=js"
export * from "./AcademyPage.vue?vue&type=script&lang=js"

import "./AcademyPage.vue?vue&type=style&index=0&id=7c320558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c320558"]])

export default __exports__